export const RECOMMENDATIONS_COUNT = 4;

// Education difficulty level mapping
export const EDUCATION_LEVEL_MAPPING = {
  p: 'Advanced',
  m: 'Advanced',
  b: 'Intermediate',
  a: 'Intermediate',
  hs: 'Introductory',
  jhs: 'Introductory',
};

export const PERSONALIZED = 'personalized';

export const LEVEL_FACET = 'level';
export const PRODUCT_FACET = 'product';
export const PRODUCT_TYPE_COURSE = 'course';
export const MAX_RECOMMENDATIONS = 4;
